export default function Sporzadzenie(props) {
	const date = props.children;
	const formattedDate = new Date(date).toLocaleDateString("pl-PL", {
		day: "numeric",
		month: "long",
		year: "numeric",
	});

	return (
		<time id="a11y-data-deklaracja-sporzadzenie" dateTime={date}>
			<strong>{formattedDate}</strong>
		</time>
	);
}
